import _ from 'lodash';
import React from 'react';
import Radium from 'radium';
import PropTypes from 'prop-types';
import Color from 'color';

import * as styles from '../../styles';
import {request} from '../../containers/actions';
import Content from '../../content-manager/content';
import Like from '../../social/like';
import Violation from '../../social/violation';

//Radium(Note);
export default class Note extends React.PureComponent {
    static contextTypes = {
        store: PropTypes.object,
        user: PropTypes.object,
    }

    static defaultProps = {
        refresh: _.identity,
        toggle: _.identity,
        editable: false,
    }

    state = {
        body: this.props.data.body,
        confirmed_body: this.props.data.confirmed_body,
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.data.body !== this.props.body)
            this.setState({body: nextProps.data.body});
        if (nextProps.data.confirmed_body !== this.props.confirmed_body)
            this.setState({confirmed_body: nextProps.data.confirmed_body});
    }

    render() {
        const displacement = this.props.index === undefined ? 0 : Math.min(4, this.props.index * 2.1 + 1.4);
        return <div
            key='container'
            style={{
                position: 'relative',
                borderRadius: '.35em',
                overflow: 'hidden',
                border: '.0625em solid #b1a54e',
                backgroundColor: 'white',
                transition: 'top 500ms, margin-bottom 500ms, max-height 500ms',
                top: this.props.open ? `-${displacement}em` : '0em',
                marginTop: '-.0625em',
                marginBottom: this.props.open ? `-${displacement}em` : '0em',
                maxHeight: this.props.open ? '50em' : '2.1em',
                ':hover': {
                    top: `-${displacement}em` ,
                    marginBottom: `-${displacement}em` ,
                    maxHeight: this.props.open ? '50em' : `${displacement + 2.1}em`,
                },
            }}
            onClick={this.props.open ? undefined : this.props.toggle}>
            <div
                style={{
                    backgroundColor: Radium.getState(this.state, 'container', ':hover') || this.props.open ? '#fcec6f' : '#fcf5c2',
                    padding: '.2em',
                }}
                onClick={this.props.toggle}>
                {this.props.data.author.firstname} {this.props.data.author.lastname}
                &nbsp;-&nbsp;
                {this.props.data.subject}
                &nbsp;-&nbsp;
                {this.props.data.type.label}
                {this.props.data.author.id === this.context.user.id
                    ? <div
                        style={{
                            position: 'absolute',
                            top: '.25em',
                            right: '55%',
                            fontSize: '.93em',
                            color: !this.props.data.confirmed
                                ? styles.alertColor
                                : this.props.data.body !== this.props.data.confirmed_body
                                    ? styles.alertColor
                                    : styles.successColor,
                        }}>
                        {!this.props.data.confirmed
                            ? window.gettext('Pending Confirmation')
                            : this.props.data.body !== this.props.data.confirmed_body
                                ? window.gettext('Pending Reconfirmation')
                                : window.gettext('Confirmed')
                        }
                    </div>
                    : null
                }
                {this.context.user.id
                    ? <div
                        style={{
                            position: 'absolute',
                            left: '.5em',
                            top: '.15em',
                            fontSize: '1.2em',
                        }}>
                        {this.context.user.hasPerm('book.note')
                            ? <span>
                                <i
                                    key='trash'
                                    style={{
                                        cursor: 'pointer',
                                        fontSize: '1.2em',
                                        color:  '#9a9a9a',
                                        ':hover': {color: '#5a5a5a'},
                                    }}
                                    className='fa-trash'
                                    onClick={async () => {
                                        await this.context.store.dispatch(request({
                                            path: `/note/${this.props.data.id}/`,
                                            method: 'DELETE',
                                        }));
                                        this.props.refresh();
                                    }}>
                                </i>
                                <span style={{display: 'inline-block', width: '.4em'}}></span>
                                <i
                                    key='save'
                                    style={{
                                        cursor: 'pointer',
                                        fontSize: '1.2em',
                                        color:  '#9a9a9a',
                                        ':hover': {color: '#5a5a5a'},
                                    }}
                                    className='fa-save'
                                    onClick={async () => {
                                        await this.context.store.dispatch(request({
                                            path: `/note/${this.props.data.id}/`,
                                            method: 'PATCH',
                                            body: {
                                                body: this.state.body,
                                                confirmed_body: this.state.confirmed_body,
                                            },
                                        }));
                                        this.props.refresh();
                                    }}>
                                </i>
                                <span style={{display: 'inline-block', width: '.4em'}}></span>
                                <i
                                    key='confirm'
                                    style={{
                                        cursor: 'pointer',
                                        fontSize: '1.2em',
                                        color:  '#9a9a9a',
                                        ':hover': {color: '#5a5a5a'},
                                    }}
                                    className={`fa ${this.props.data.confirmed ? 'fa-times' : 'fa-check'}`}
                                    onClick={async () => {
                                        await this.context.store.dispatch(request({
                                            path: `/note/${this.props.data.id}/`,
                                            method: 'PATCH',
                                            body: {
                                                confirmed: !this.props.data.confirmed,
                                            },
                                        }));
                                        this.props.refresh();
                                    }}>
                                </i>
                                <span style={{display: 'inline-block', width: '.4em'}}></span>
                            </span>
                            : this.props.editable && this.props.data.author.id === this.context.user.id
                                ? <span>
                                    <i
                                        key='save'
                                        style={{
                                            fontSize: '1.2em',
                                            cursor: 'pointer',
                                            color: '#9a9a9a',
                                            ':hover': {color: '#5a5a5a'},
                                        }}
                                        className='fa-save'
                                        onClick={async () => {
                                            await this.context.store.dispatch(request({
                                                path: `/note/${this.props.data.id}/`,
                                                method: 'PATCH',
                                                body: {
                                                    body: this.state.body,
                                                },
                                            }));
                                            this.props.refresh();
                                        }}>
                                    </i>
                                    <span style={{display: 'inline-block', width: '.4em'}}></span>
                                </span>
                                : null
                        }
                        <i
                            key='bookmark'
                            style={{
                                cursor: 'pointer',
                                color: this.props.data.bookmarked ? styles.fourthColor : '#9a9a9a',
                                ':hover': {color: this.props.data.bookmarked ? (new Color(styles.fourthColor)).lighten(.1).hex() : '#5a5a5a'},
                            }}
                            className={`fa fa-${this.props.data.bookmarked ? 'heart' : 'heart-o'}`}
                            onClick={async event => {
                                event.preventDefault();
                                await this.context.store.dispatch(request({
                                    path: `/note/${this.props.data.id}/${this.props.data.bookmarked ? 'unbookmark' : 'bookmark'}/`,
                                    method: 'POST',
                                }));
                                this.props.refresh();
                            }}>
                        </i>
                        <span style={{display: 'inline-block', width: '.4em'}}></span>
                        <Like target={['note', this.props.data.id]}/>
                        <span style={{display: 'inline-block', width: '.4em'}}></span>
                        <i
                            key='follow'
                            style={{
                                cursor: 'pointer',
                                color: this.props.data.following ? styles.successColor : '#9a9a9a',
                                ':hover': {color: this.props.data.following ? (new Color(styles.successColor)).lighten(.1).hex() : '#5a5a5a'},
                            }}
                            className={`fa fa-${this.props.data.following ? 'user-times' : 'user-plus'}`}
                            onClick={async event => {
                                event.preventDefault();
                                await this.context.store.dispatch(request({
                                    path: `/note/${this.props.data.id}/${this.props.data.following ? 'unfollow' : 'follow'}/`,
                                    method: 'POST',
                                }));
                                this.props.refresh();
                            }}>
                        </i>
                    </div>
                    : null
                }
            </div>
            <div>
                {this.context.user.hasPerm('book.note')
                    ? <div style={styles.shadowBox}>
                        <Content
                            inline
                            content={(this.state.confirmed_body || '')}
                            style={{
                                ...styles.field,
                                height: undefined,
                                minHeight: '5em',
                                display: 'inline-block',
                                width: '100%',
                                overflowY: 'auto',
                                overflowX: 'hidden',
                                maxHeight: '12em',
                            }}
                            onChange={content => this.setState({confirmed_body: content})}
                        />
                        {this.props.data.body !== this.props.data.confirmed_body
                            ? [
                                <hr key='separator'/>,
                                <i
                                    key='confirm-body'
                                    style={{
                                        fontSize: '1.2em',
                                        cursor: 'pointer',
                                        color: '#9a9a9a',
                                        ':hover': {color: '#5a5a5a'},
                                    }}
                                    className='fa-check'
                                    onClick={async () => {
                                        await this.context.store.dispatch(request({
                                            path: `/note/${this.props.data.id}/`,
                                            method: 'PATCH',
                                            body: {
                                                confirmed_body: this.state.body,
                                            },
                                        }));
                                        this.props.refresh();
                                    }}>
                                </i>,
                                <Content
                                    key='body'
                                    inline
                                    content={(this.state.body || '')}
                                    style={{
                                        ...styles.field,
                                        height: undefined,
                                        minHeight: '5em',
                                        display: 'inline-block',
                                        width: '100%',
                                        overflowY: 'auto',
                                        overflowX: 'hidden',
                                        maxHeight: '12em',
                                    }}
                                    onChange={content => this.setState({body: content})}
                                />,
                            ]
                            : null
                        }
                    </div>
                    : this.props.editable && this.props.data.author.id === this.context.user.id
                        ? <div>
                            <Content
                                key='body'
                                inline
                                content={(this.state.body || '')}
                                style={{
                                    ...styles.field,
                                    height: undefined,
                                    minHeight: '5em',
                                    display: 'inline-block',
                                    width: '100%',
                                    overflowY: 'auto',
                                    overflowX: 'hidden',
                                    maxHeight: '12em',
                                }}
                                onChange={content => this.setState({body: content})}
                            />
                        </div>
                        : <div
                            dangerouslySetInnerHTML={{__html: this.props.data.confirmed_body}}
                            style={{
                                ...styles.shadowBox,
                                display: 'inline-block',
                                width: '100%',
                                overflowY: 'auto',
                                overflowX: 'hidden',
                                maxHeight: '12em',
                            }}>
                        </div>
                }
                {this.context.user.id && this.props.data.author.id !== this.context.user.id
                    ? <div
                        style={{
                            display: this.props.open ? undefined : 'none',
                            position: 'absolute',
                            bottom: '.5em',
                            left: '.5em',
                            fontSize: '.8em',
                        }}>
                        <Violation target={['note', this.props.data.id]}/>
                        &nbsp;
                    </div>
                    : null
                }
            </div>
        </div>;
    }
}
